/**
 * One-Stop Hub — small helpers for building affiliate & search URLs from
 * partner_brand templates. Falls back to `default_base_url` when a template
 * placeholder can't be resolved.
 */
export function buildAffiliateUrl(brand) {
    if (!brand) return "#";
    const tmpl = brand.affiliate_url_template;
    if (tmpl && brand.affiliate_id) {
        return tmpl.replace("{affiliate_id}", encodeURIComponent(brand.affiliate_id));
    }
    // Strip unused {affiliate_id} placeholder if template exists but id doesn't.
    if (tmpl) return tmpl.replace(/[?&]?[a-z_]+={affiliate_id}/gi, "").replace(/[?&]$/, "");
    return brand.default_base_url || "#";
}

export function buildSearchUrl(brand, query) {
    if (!brand || !query) return brand?.default_base_url || "#";
    const q = encodeURIComponent(query.trim());
    const tmpl = brand.search_url_template;
    if (!tmpl) return brand.default_base_url || "#";
    let out = tmpl.replace("{query}", q);
    if (brand.affiliate_id) {
        out = out.replace("{affiliate_id}", encodeURIComponent(brand.affiliate_id));
    } else {
        // Remove unused affiliate placeholder + trailing separators.
        out = out.replace(/[?&]?[a-z_]+={affiliate_id}/gi, "").replace(/[?&]$/, "");
    }
    return out;
}
